import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useT } from "../i18n";
import { fetchShared, type Project } from "../api";
import { Empty, StatusBadge } from "../components/ui";
import { PartThumb } from "../scene/PartThumb";

export function SharedPage() {
  const tr = useT();
  const { token = "" } = useParams();
  const [project, setProject] = useState<Project | null>(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    fetchShared(token).then(setProject).catch(() => setErr(true));
  }, [token]);

  if (err) return <Empty icon="share">{tr("Lien de partage invalide ou expiré.")}</Empty>;
  if (!project) return <div className="muted">Chargement…</div>;
  const files = project.files ?? [];

  return (
    <div>
      <div className="page-head">
        <div>
          <div className="eyebrow" style={{ marginBottom: 8 }}>{tr("Projet partagé · lecture seule")}</div>
          <h1>{project.name}</h1>
          <div className="sub">{project.description || "—"}</div>
        </div>
        <span className="badge accent"><span className="dot" />{tr("partagé")}</span>
      </div>

      {files.length === 0 ? (
        <Empty icon="box">{tr("Ce projet partagé ne contient aucun fichier.")}</Empty>
      ) : (
        <div className="card" style={{ padding: 0 }}>
          <table className="table">
            <thead><tr><th>Nom</th><th>Source</th><th>{tr("Machine · matière")}</th><th>Statut</th></tr></thead>
            <tbody>
              {files.map((f) => (
                <tr key={f.id}>
                  <td>
                    <div className="row" style={{ gap: 11 }}>
                      <PartThumb material={f.material} passed={f.passed} size={40} />
                      <span style={{ fontWeight: 600 }}>{f.name}</span>
                    </div>
                  </td>
                  <td><span className="badge">{f.generator || f.kind}</span></td>
                  <td className="muted" style={{ fontSize: 12 }}>{f.printer_profile} · {f.material}</td>
                  <td><StatusBadge passed={f.passed} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
